export function mapBoardToPriceData({
  additionalFees,
  bighead,
  bigheadCurrency,
  cancellationFrom,
  insurance,
  pdp,
  isMobile,
  isPrime,
  nights,
  paymentPolicy,
  payRate = 0,
  roomName,
  roomsNumber,
  sellingRate,
  sellingRateCurrency,
  staywallet,
  staywalletCurrency,
  subtotal,
  subtotalCurrency,
  pricePerNightSubtotal,
  pricePerNightSubtotalCurrency,
  taxes,
  taxesCurrency,
  total,
  totalCurrency,
  totalWithFees,
  totalWithFeesCurrency,
  pricePerNightWithFees,
  pricePerNightWithFeesCurrency,
}) {
  return {
    additionalFees,
    bighead,
    bigheadCurrency,
    insurance: insurance?.amount,
    insuranceCurrency: insurance?.currency,
    pdp: pdp?.amount,
    pdpCurrency: pdp?.currency,
    isMobile: isMobile || false,
    isPrime: isPrime || false,
    nights,
    payDate: cancellationFrom,
    payLate: payRate ? total - payRate : null,
    paymentPolicy,
    payNow: payRate,
    roomsBooked: `${roomsNumber} x ${roomName}`,
    roomsNumber,
    sellingRate,
    sellingRateCurrency,
    staywallet,
    staywalletCurrency,
    subtotal,
    subtotalCurrency,
    pricePerNightSubtotal,
    pricePerNightSubtotalCurrency,
    taxes,
    taxesCurrency,
    total,
    totalCurrency,
    totalWithFees,
    totalWithFeesCurrency,
    pricePerNightWithFees,
    pricePerNightWithFeesCurrency,
  }
}

export function mapBoardCollectionToPriceData(boards = [], totals = {}) {
  const priceDataCollection = boards.map(board =>
    mapBoardToPriceData({ ...board, insurance: null })
  )

  const priceData = priceDataCollection.reduce((totalPriceData, currentPriceData) => {
    if (!totalPriceData) {
      return currentPriceData
    }
    const bighead = totalPriceData.bighead + currentPriceData.bighead
    const sellingRate = totalPriceData.sellingRate + currentPriceData.sellingRate
    const roomsBooked = `${totalPriceData.roomsBooked}\n${currentPriceData.roomsBooked}\n`
    const total = totalPriceData.total + currentPriceData.total
    const subtotal = totalPriceData.subtotal + currentPriceData.subtotal
    const payNow = totalPriceData.payNow + currentPriceData.payNow
    const payLate = totalPriceData.payLate + currentPriceData.payLate
    const taxes = totalPriceData.taxes + currentPriceData.taxes
    const isPrime = currentPriceData.isPrime || totalPriceData.isPrime
    const totalWithFees = totalPriceData.totalWithFees + currentPriceData.totalWithFees
    const additionalFees = [...totalPriceData.additionalFees, ...currentPriceData.additionalFees]
    const roomsNumber = totalPriceData.roomsNumber + currentPriceData.roomsNumber

    return {
      ...totalPriceData,
      ...currentPriceData,
      bighead,
      isPrime,
      roomsBooked,
      sellingRate,
      total,
      subtotal,
      payNow,
      payLate,
      taxes,
      totalWithFees,
      additionalFees,
      roomsNumber,
    }
  })

  return { ...priceData, ...totals }
}

export const mapBoardWithAvailabilityTotals = (board, availabilityTotals) => {
  return {
    ...board,
    ...availabilityTotals?.find(({ availabilityId }) => availabilityId === board.availabilityId),
  }
}
